<p-sidebar
  [modal]="true"
  [visible]="isOpen"
  [position]="position"
  [style]="{ width }"
  [showCloseIcon]="false"
  [baseZIndex]="10000"
  (onHide)="closePopup()"
  (onShow)="sidebarLastCallsCanvasComponent.loadMe();announcementCanvas.loadData({},{})"
  [class]="'sidebar-announcement'"
>
  <div class="custom-tab-1">
    <div class="d-flex-between tab-header">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <a class="nav-link active" data-bs-toggle="tab" href="#announcement" aria-selected="true"
             role="tab">{{ 'user-announcement.announcement'  | translate }}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" data-bs-toggle="tab" href="#lastcalls" aria-selected="true"
             role="tab">{{ 'user-calls.last-calls'  | translate }}</a>
        </li>
      </ul>
      <button type="button" class="btn p-0" (click)="closePopup()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>


    <div class="tab-content">
      <div class="tab-pane fade active show" id="announcement" role="tabpanel">
        <app-core-announcement-canvas #announcementCanvas (open)="openAnnouncement($event)" (openArray)="openAnnouncementArray($event)"
                                      (choose)="save()"></app-core-announcement-canvas>
      </div>

      <div class="tab-pane fade" id="lastcalls" role="tabpanel">
        <app-core-last-calls-canvas #sidebarLastCallsCanvasComponent
                                    (open)="openCallCard($event)"></app-core-last-calls-canvas>
      </div>
    </div>
  </div>
</p-sidebar>
<announcement-modal
  #announcementReadModal
  (saveEmitter)="save()"
/>

<app-call-card-view-popup
  #callViewPopupComponent
/>
